var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarlightLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 994 266",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        fill: #175572;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 21.33,
    y: 14.55,
    width: 936.43,
    height: 221
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_629",
    "data-name": "Group 629"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_627",
    "data-name": "Group 627"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_618",
    "data-name": "Group 618"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2304",
    "data-name": "Path 2304",
    className: "cls-3",
    d: "M310.11,200.8v7.07c-8.12,1.66-11.08.2-16.35-8.18-1.45,1.17-2.86,2.33-4.3,3.45-9.09,7.13-19.35,8.51-30.08,5.16-12.4-3.88-18.98-17.26-15.19-29.7,1.97-6.46,6.38-10.58,12.37-13.26,7.81-3.51,16.15-3.82,24.49-4.1,3.56-.12,7.12-.02,11.5-.02-.24-4.69.05-8.89-.77-12.85-2.12-10.36-11.4-13.36-20.67-12.38-6.58.69-9.54,2.44-17.51,9.43-1.7-1.97-3.47-4.02-5.35-6.19,7.22-8.97,16.28-12.05,26.56-11.92,16.67.22,26.32,10.04,26.51,26.8.12,10.43.03,20.87.03,31.3,0,1.52-.02,3.04.02,4.55.24,7.97,1.04,8.98,8.74,10.85M293.02,170.4c-8.02,0-14.8-.23-21.55.1-3.4.24-6.74.97-9.93,2.18-6.5,2.33-9.37,6.49-9.42,12.71-.04,6.96,3.35,12.21,9.72,14.52,10.42,3.78,24.6.3,28.97-13.45,1.56-4.92,1.48-10.37,2.21-16.07"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_619",
    "data-name": "Group 619"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2305",
    "data-name": "Path 2305",
    className: "cls-3",
    d: "M708.62,143.55c0-3.34-.04-6.67.02-10.01.03-1.54.15-3.42,2.31-2.96.8.17,1.32,1.82,1.89,2.84.16.29.04.75.04,1.12-.04,23.34,0,46.68-.18,70.02-.05,3.6-.58,7.18-1.57,10.65-3.22,11.47-10.41,18.72-22.66,20.09-7.97,1.01-16.05-.8-22.83-5.12-2.01-1.27-3.63-3.15-5.66-4.95,1.15-1.1,1.95-1.86,2.97-2.85,4.16,4.19,9.47,7.05,15.25,8.23,15.33,3.02,25.71-3.46,29.23-18.56,1.31-6.82,1.44-13.81.39-20.67-1.27,1.7-2.34,3.16-3.43,4.58-9.01,12.08-26.11,14.57-38.2,5.56-1.78-1.32-3.38-2.86-4.79-4.57-4.75-5.74-7.76-12.72-8.69-20.11-1.85-12.55-.6-24.66,6.55-35.54,7.31-11.13,20.2-15.49,32.38-11.23,5.04,1.78,9.45,5.01,12.67,9.28,1.12,1.44,2.19,2.92,3.28,4.38l1.03-.19M656.5,167.76c-.29,7.45,1.39,14.84,4.88,21.42,4.47,8.3,11.31,13.44,20.88,13.5,9.82.07,17.04-5,21.29-13.69,6.93-14.16,6.92-28.57-.08-42.71-4.18-8.45-11.17-13.39-20.82-13.48-9.91-.09-16.8,5.11-21.36,13.6-3.46,6.56-5.12,13.93-4.81,21.35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_620",
    "data-name": "Group 620"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2306",
    "data-name": "Path 2306",
    className: "cls-3",
    d: "M788.28,98.21h5.16v41.54c1.91-1.55,3.03-2.36,4.03-3.3,7.67-7.24,16.88-9.23,26.91-7.28,6.85,1.34,11.97,5.53,15.46,11.6,2.87,4.74,4.47,10.14,4.67,15.68.24,16.31.08,32.63.08,49.42l-5.62.6v-5.9c0-12.15.12-24.31-.07-36.46.02-4.55-.48-9.09-1.47-13.54-4.17-16.97-23.61-22.18-36.12-9.84-5.63,5.56-7.58,12.57-7.63,20.22-.08,12.91-.02,25.83-.03,38.74v6.36h-5.02c-1.18-1.33-1.57-97.36-.35-107.84"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_621",
    "data-name": "Group 621"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2307",
    "data-name": "Path 2307",
    className: "cls-3",
    d: "M955.56,198.82c.87,2.67,1.55,4.79,2.21,6.82-10.44,6.46-27.93,4.12-30.9-13.05-.56-3.56-.83-7.16-.8-10.77-.09-12.34-.04-24.68-.04-37.02v-6.71l-11.72-.75v-7.44l11.71-.71v-19.04h8.27v19.18h20.95v8.3h-20.39c-.18,2-.42,3.45-.42,4.91-.03,13.86-.03,27.72,0,41.58-.03,1.9.07,3.8.3,5.68,1.21,8.76,6.63,12.55,15.28,10.7,1.64-.35,3.22-.97,5.54-1.68"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_622",
    "data-name": "Group 622"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2308",
    "data-name": "Path 2308",
    className: "cls-3",
    d: "M67.39,135.75l-2.87,3.81c-.6-.09-1.18-.27-1.73-.54-6.49-5-13.91-5.68-21.64-4.51-6.78,1.03-10.89,5.58-11.86,12.67-.96,6.98,1.86,12.42,8.45,15.04,4.37,1.74,9.05,2.72,13.55,4.15,3.06.97,6.12,1.97,9.08,3.22,15.49,6.53,13.25,26.52,2.62,33.58-4.63,3.03-10.01,4.7-15.54,4.84-10.1.43-19.02-2.37-26.11-10.42l3.35-3.68c.71.54,1.3.91,1.8,1.38,7.74,7.26,16.87,9.18,26.88,6.4,3.09-.88,5.92-2.47,8.27-4.66,7.33-7.02,5.41-18.44-3.81-22.58-4.46-2-9.33-3.08-14.01-4.56-2.34-.74-4.75-1.31-7.04-2.19-9.4-3.65-13.77-10.32-13.02-19.69.8-9.97,5.95-16.44,15.56-18.5,8.03-1.89,16.48-.77,23.74,3.15,1.51.94,2.96,1.98,4.34,3.09"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_623",
    "data-name": "Group 623"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2309",
    "data-name": "Path 2309",
    className: "cls-3",
    d: "M144.03,111.56h5.91v19.4h21.07v4.98l-21.13.5v8.49c0,12.7-.05,25.4.04,38.1,0,2.84.29,5.67.84,8.45,1.6,7.96,6.03,11.21,14.16,10.52,2.05-.17,4.07-.71,6.67-1.19l1.48,4.26c-15.56,7.09-26.62-1.79-28-13.68-.41-3-.65-6.02-.73-9.05-.08-13.08-.03-26.16-.03-39.24v-6.57l-11.51-.63c-.11-1.47-.22-2.84-.37-4.79h11.62v-19.55Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_624",
    "data-name": "Group 624"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2310",
    "data-name": "Path 2310",
    className: "cls-3",
    d: "M373.58,130.49h5.43c.25,2.85.51,5.73.84,9.51,6.3-6.91,13.13-11.14,22.41-11.16.1,2.18.18,4,.26,5.78-.76.4-1.23.84-1.73.88-9.9.85-15.69,6.57-18.87,15.6-2.04,5.82-2.44,11.84-2.47,17.92-.04,10.42-.01,20.85-.02,31.27v6.2l-5.53.48c-1.26-4.5-1.48-70.14-.33-76.48"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_625",
    "data-name": "Group 625"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2311",
    "data-name": "Path 2311",
    className: "cls-3",
    d: "M484.89,96.38v87.2c0,1.89-.06,3.8.11,5.68.51,5.45,2.03,10.17,8.84,10.61-.14,1.37-.24,2.42-.34,3.43-6.77-.1-10.38-2.57-11.89-8.52-.75-3.13-1.11-6.34-1.09-9.56-.08-27.85-.05-55.7-.05-83.54,0-1.14-.02-2.28.05-3.41.16-2.51,1.79-2.49,4.37-1.88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_626",
    "data-name": "Group 626"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2312",
    "data-name": "Path 2312",
    className: "cls-3",
    d: "M570.56,128.88h3.72v73.7l-3.72.23v-73.93Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_628",
    "data-name": "Group 628"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2314",
    "data-name": "Path 2314",
    className: "cls-3",
    d: "M572.19,60.33l-17.93-45.78,15.69,46.6-43.17-23.54,41.97,25.61-48.2,9.71,48.62-7.36-30.68,38.42,32.51-36.89,1.2,49.16,1.2-49.16,32.51,36.89-30.68-38.42,48.62,7.36-48.2-9.71,41.97-25.61-43.17,23.54,15.69-46.6-17.94,45.78Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarlightLogo);
export default __webpack_public_path__ + "static/media/starlight-logo.f668d794316dc23dd47501d18763194c.svg";
export { ForwardRef as ReactComponent };